import { useState, useEffect } from "react";
import { Header } from "./components/header/Header";
import { Main } from "./components/Main";

import "./components/typography.css";
import { Footer } from "./components/footer/Footer";
import NewMain from "./components/NewMain";
import axios from "axios";

const setFaviconAndMetadata = (lvvEnabled) => {
  const faviconName = lvvEnabled ? "faviconlvv.ico" : "favicon.ico";
  const descriptionText = lvvEnabled
    ? "Lupa- ja valvontaviraston ylläpitämä rekisteri kiinteistövälitysliikkeistä ja vuokrahuoneistojen välitysliikkeistä"
    : "Aluehallintoviraston ylläpitämä rekisteri kiinteistövälitysliikkeistä ja vuokrahuoneistojen välitysliikkeistä";
  const titleText = lvvEnabled
    ? "Välitysliikerekisteri"
    : "Välitysliikerekisteri | Aluehallintovirasto";

  document.title = titleText;

  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute("content", descriptionText);
  }

  setFavicon(faviconName);
};

const setFavicon = (filename) => {
  const existingFavicon = document.querySelector('link[rel="icon"]');
  const newFavicon = document.createElement("link");

  newFavicon.rel = "icon";
  newFavicon.type = "image/x-icon";
  newFavicon.href = `${
    process.env.PUBLIC_URL
  }/${filename}?v=${new Date().getTime()}`; // cache-busting

  if (existingFavicon) {
    document.head.removeChild(existingFavicon);
  }

  document.head.appendChild(newFavicon);
};

const App = () => {
  const [featureFlags, setFeatureFlags] = useState({ lvvEnabled: false });

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("/api/FeatureFlags");
      setFeatureFlags(response.data);
      setFaviconAndMetadata(response.data.lvvEnabled);
    };

    const postData = async () => {
      const response = await axios.post("api/FeatureFlags");
      setFeatureFlags(response.data);
      setFaviconAndMetadata(response.data.lvvEnabled);
    };

    fetchData().catch(console.error);

    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.altKey && e.shiftKey && e.key.toLowerCase() === "t") {
        postData();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <>
      <div
        className={featureFlags.lvvEnabled ? "app_wrapper_new" : "app_wrapper"}
      >
        {featureFlags.lvvEnabled ? (
          <NewMain />
        ) : (
          <>
            <Header />
            <Main />
          </>
        )}
      </div>
      {!featureFlags.lvvEnabled && <Footer />}
    </>
  );
};

export default App;
